import { render, staticRenderFns } from "./ticketInfo.vue?vue&type=template&id=1d81f9fa&scoped=true"
import script from "./ticketInfo.vue?vue&type=script&lang=js"
export * from "./ticketInfo.vue?vue&type=script&lang=js"
import style0 from "./ticketInfo.vue?vue&type=style&index=0&id=1d81f9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d81f9fa",
  null
  
)

export default component.exports